import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import { BookingWizardDataAtom } from "../../stores";

export const setRateIdAtom = atom(null, (get, set, rateId: string) => {
  const bookingWizardData = get(BookingWizardDataAtom);
  if (!bookingWizardData) {
    //@TODO: this is an error
    return;
  }

  if (bookingWizardData.type === "GolfBooking") {
    const newBookingWizardData: BookingWizard.BookingWizardData = {
      ...bookingWizardData,
      rateId,
    };
    set(BookingWizardDataAtom, newBookingWizardData);
  }
});
